import { Box, Button, Flex, HStack, Text } from "@chakra-ui/react";
import { useState } from "react";

const QuizQuestion = ({
  question,
  options,
  onAnswer,
  totalQuestion,
  currentQuestionIndex,
}: {
  question: string;
  options: { id: number; answer: string }[];
  onAnswer: (answer: number) => void;
  totalQuestion: number;
  currentQuestionIndex: number;
}) => {
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  
 

  const handleAnswerChange = (answer: string) => {
    // trying to see if state is the reason it failed
    setSelectedOption(Number(answer));
    const selected = localStorage.setItem('quizAnswer', answer);
  }

  


  return (
    <div>
      <HStack py="8px" px="10px">
        <Text fontWeight="500" fontSize="17px">
          {currentQuestionIndex + 1}.
        </Text>
        <Text fontWeight="500" fontSize="17px">
          {question}
        </Text>
      </HStack>

      {options.map((option) => (
        <div key={option.id}>
          <Box px="10px" pt="10px">
            <HStack>
              <input
                type="radio"
                name={question}
                value={option.id}
                checked={selectedOption === option.id}
                // onChange={(e) => {console.log(Number(e.target.value), "selected option");setSelectedOption(Number(e.target.value))}}
                onChange={(e) => handleAnswerChange(e.target.value)}
              />
              <Text px="10px">{option.answer}</Text>
            </HStack>
          </Box>
        </div>
      ))}
      <Flex justifyContent="flex-end">
        <Button
          py="13px"
          px="30px"
          mt="30px"
          ml="20px"
          onClick={() => selectedOption !== null && onAnswer(selectedOption)}
          borderRadius="1px"
          fontSize={14}
          colorScheme="red"
          size="md"
        >
          {currentQuestionIndex === totalQuestion - 1 ? "SUBMIT" : "NEXT"}
        </Button>
      </Flex>
    </div>
  );
};

export default QuizQuestion;
